import { firm } from "@/lib/content";

export type FirmAddress = {
  line1: string;
  line2: string;
  line3: string;
  line4: string;
  lat: number;
  lng: number;
};

export type FirmContact = {
  phone: string;
  email: string;
  hours: string;
  address: FirmAddress;
};

export const defaultFirmContact: FirmContact = {
  phone: firm.phone,
  email: firm.email,
  hours: firm.hours,
  address: { ...firm.address },
};

export function parseFirmContact(raw: unknown): FirmContact {
  if (!raw || typeof raw !== "object") return defaultFirmContact;
  const v = raw as Record<string, unknown>;
  const addr = (v.address ?? {}) as Record<string, unknown>;
  return {
    phone: typeof v.phone === "string" && v.phone ? v.phone : defaultFirmContact.phone,
    email: typeof v.email === "string" && v.email ? v.email : defaultFirmContact.email,
    hours: typeof v.hours === "string" && v.hours ? v.hours : defaultFirmContact.hours,
    address: {
      line1: typeof addr.line1 === "string" ? addr.line1 : defaultFirmContact.address.line1,
      line2: typeof addr.line2 === "string" ? addr.line2 : defaultFirmContact.address.line2,
      line3: typeof addr.line3 === "string" ? addr.line3 : defaultFirmContact.address.line3,
      line4: typeof addr.line4 === "string" ? addr.line4 : defaultFirmContact.address.line4,
      lat: typeof addr.lat === "number" ? addr.lat : Number(addr.lat) || defaultFirmContact.address.lat,
      lng: typeof addr.lng === "number" ? addr.lng : Number(addr.lng) || defaultFirmContact.address.lng,
    },
  };
}

export function formatOfficeAddress(contact: FirmContact): string {
  const { line1, line2, line3, line4 } = contact.address;
  return [line1, line2, line3, line4].filter(Boolean).join("\n");
}

export function googleMapsEmbedUrl(contact: FirmContact): string {
  const { lat, lng } = contact.address;
  return `https://www.google.com/maps?q=${lat},${lng}&z=17&output=embed`;
}

export function googleMapsLinkUrl(contact: FirmContact): string {
  const { lat, lng } = contact.address;
  return `https://www.google.com/maps/search/?api=1&query=${lat},${lng}`;
}
